var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7983 4.77924C14.698 4.49059 13.5848 4.26654 12.4619 4.10303C12.6037 5.23355 12.6813 6.39827 12.6986 7.53293H15.9999C15.982 6.62326 15.9201 5.68309 15.7983 4.77924Z",
    fill: "#7E4CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49636 3.98495C4.34071 5.15363 4.25837 6.35754 4.23999 7.53132H7.53064V3.78149C6.52679 3.79687 5.49445 3.87153 4.49636 3.98495Z",
    fill: "#7E4CE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7322 0.150262C9.99035 0.0659115 9.21504 0.0146262 8.46973 0V2.84757C9.425 2.86167 10.4091 2.92389 11.3596 3.02412C11.1997 2.06076 10.9858 1.10321 10.7322 0.150262Z",
    fill: "#7E4CE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5053 3.98637C10.5067 3.87289 9.47397 3.80138 8.46973 3.78613V7.53093H11.7594C11.7409 6.35787 11.6608 5.15455 11.5053 3.98637Z",
    fill: "#7E4CE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6483 2.8433C11.6498 2.72982 10.617 2.65832 9.61279 2.64307V6.38786H12.9024C12.884 5.2148 12.8039 4.01149 12.6483 2.8433Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46973 13.176V15.9999C9.21935 15.9852 9.99897 15.9335 10.7452 15.8483C10.9973 14.9019 11.209 13.95 11.3683 12.9922C10.414 13.0954 9.42697 13.1615 8.46973 13.176Z",
    fill: "#7E4CE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26718 0.150324C5.01384 1.10215 4.79912 2.05854 4.6394 3.02096C5.59024 2.92064 6.5749 2.85657 7.53046 2.84235V0C6.7849 0.0146262 6.00937 0.0658803 5.26718 0.150324Z",
    fill: "#7E4CE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62939 12.9922C4.78874 13.9501 5.00421 14.9019 5.25636 15.8487C6.00198 15.9338 6.78107 15.9855 7.53023 16.0001V13.176C6.57217 13.1615 5.58439 13.0955 4.62939 12.9922Z",
    fill: "#7E4CE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.202281 4.77263C0.080031 5.67864 0.0178749 6.6209 0 7.53269H3.30027C3.31752 6.39954 3.39686 5.23629 3.53827 4.10742C2.41618 4.27084 1.30168 4.48439 0.202281 4.77263Z",
    fill: "#7E4CE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22534 8.46948C4.24369 9.64936 4.34809 10.8581 4.505 12.0318C5.50103 12.147 6.53027 12.2224 7.52996 12.238V8.46948H4.22534Z",
    fill: "#7E4CE8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_14_4191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08252 9.6123C3.10086 10.7922 3.20527 12.001 3.36217 13.1746C4.3582 13.2898 5.38745 13.3653 6.38713 13.3808V9.6123H3.08252Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28555 8.46948H0C0.0178749 9.37915 0.0798747 10.3194 0.201656 11.2234C1.30828 11.5162 2.42259 11.7473 3.54339 11.9135C3.40065 10.7787 3.30268 9.60964 3.28555 8.46948Z",
    fill: "#7E4CE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66784 12.877C2.56419 12.7228 1.46444 12.5242 0.373291 12.251C0.562665 13.3077 0.730759 13.9977 0.941664 14.7374C0.986164 14.8933 1.1086 15.0158 1.26457 15.0603C2.20128 15.3274 3.08419 15.532 4.23822 15.7143C4.00015 14.7743 3.8175 13.8272 3.66784 12.877Z",
    fill: "#7E4CE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3304 12.8787C12.1809 13.8282 12.0001 14.7748 11.7622 15.714C12.9173 15.5316 13.7991 15.3271 14.7353 15.0601C14.8913 15.0156 15.0137 14.8932 15.0582 14.7372C15.2672 14.004 15.4365 13.3125 15.6273 12.2466C14.535 12.5201 13.435 12.7244 12.3304 12.8787Z",
    fill: "#7E4CE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26414 0.943072C1.1082 0.987575 0.985736 1.11002 0.941236 1.266C0.731925 2.00003 0.56255 2.69196 0.371582 3.75961C1.45614 3.49099 2.55495 3.29776 3.65967 3.14622C3.80998 2.18758 4.01666 1.23466 4.25701 0.285645C3.09139 0.468753 2.20098 0.675863 1.26414 0.943072Z",
    fill: "#7E4CE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46973 8.46951V12.2344C9.46925 12.2187 10.4985 12.1461 11.4946 12.0308C11.6514 10.8575 11.758 9.6492 11.7763 8.46948H8.46973V8.46951Z",
    fill: "#7E4CE8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7165 8.46951C12.6994 9.61101 12.5995 10.7812 12.4565 11.9172C13.5776 11.7511 14.6915 11.5131 15.7986 11.2203C15.9201 10.3173 15.9821 9.37815 15.9999 8.46948H12.7165V8.46951Z",
    fill: "#7E4CE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.058 1.26622C15.0136 1.11027 14.8911 0.987794 14.7351 0.943291C13.796 0.675394 12.9049 0.468409 11.741 0.285645C11.981 1.2336 12.1865 2.18551 12.3367 3.14293C13.4415 3.29432 14.5415 3.48274 15.6262 3.7513C15.4365 2.69299 15.2684 2.00363 15.058 1.26622Z",
    fill: "#7E4CE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4191",
    x: 7.71279,
    y: 0.743066,
    width: 7.08955,
    height: 7.54487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_14_4191",
    x: 1.18252,
    y: 7.7123,
    width: 7.10469,
    height: 7.56855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4191",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.bda9960ddc6c31e3c154dc631a2b1ad2.svg";
export { ForwardRef as ReactComponent };